let globalAbortController = new AbortController();

export const getGlobalAbortController = () => globalAbortController;
export const resetGlobalAbortController = () => {
    globalAbortController.abort();
    globalAbortController = new AbortController();
};
